import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import * as React from 'react';

const SEPlayEditButton = ({ handleEditButton, label }) => {
    return (
        <>
            <Grid item sm={4} justifyContent={'flex-end'}>
                <Button
                    aria-label="edit-button"
                    variant="contained"
                    sx={{ borderRadius: 0, fontSize: '13px' }}
                    onClick={handleEditButton}
                >
                    {label}
                </Button>
            </Grid>
        </>
    );
};

export default SEPlayEditButton;
